<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      infrastructure_pod: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.infrastructure.infrastructure_pods.find(
          p => p.id === transaction.relationships.infrastructure_pod.data.id
        )
      },
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
    }),

    isActiveStatus: function () {
      return this.reservation_transaction &&
        // Reserved/provisioned status
        this.infrastructure_pod.attributes.pod_status > 2
    }
  }
}
</script>

<template>
  <div class="status" :class="{ active: isActiveStatus, provisioning: !isActiveStatus }">
    <div class="circle"></div>&nbsp;
    <strong v-if="isActiveStatus">Active</strong>
    <strong v-else>Provisioning</strong>
  </div>
</template>
